import { inject, Injectable } from '@angular/core';
import { fromEvent, map, startWith } from 'rxjs';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  deviceDetector = inject(DeviceDetectorService)

  private mobileBreakpoint = 1020; // px - adjust if you want
  // -------------------------
  // Device checks (user agent)
  // -------------------------

  /**
   * True if the physical device is a mobile phone.
   */
  isMobileDevice(): boolean {
    this.deviceDetector.getDeviceInfo
    return this.deviceDetector.isMobile();
  }

  /**
   * True if the physical device is a tablet.
   */
  isTabletDevice(): boolean {
    return this.deviceDetector.isTablet();
  }

  /**
   * True if the physical device is a desktop.
   */
  isDesktopDevice(): boolean {
    return this.deviceDetector.isDesktop();
  }

  getDeviceDetector(): DeviceDetectorService {
    return this.deviceDetector;
  }

  getDeviceInfo(): DeviceInfo {
    return this.deviceDetector.getDeviceInfo();
  }


  // -------------------------
  // Screen size checks
  // -------------------------

  /**
   * True if the current viewport width is below the mobile breakpoint.
   * This works even in Chrome DevTools when resizing the window.
   */
  isMobileScreen(): boolean {
    return window.innerWidth < this.mobileBreakpoint;
  }

  /**
   * Observable that emits whenever the viewport is resized.
   * Emits true if the screen width is below the mobile breakpoint.
   */
  mobileScreenChanges$ = fromEvent(window, 'resize').pipe(
    map(() => this.isMobileScreen()),
    startWith(this.isMobileScreen())
  );
}
